export default {
      id: "feuilles_agenda-usage",
      viewBox: "0 0 215 325",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#feuilles_agenda-usage",
      toString: function () {
        return this.url;
      }
    }